var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0b5d614-6770-41ec-9a79-c8b65b41bf18",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.13 255.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.fca2b066-e4da-4518-ada7-b9c6f6a890e0{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.fca2b066-e4da-4518-ada7-b9c6f6a890e0{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b438ae82-2e37-4b0e-b508-84a170b1037b",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M11.79,244.41V175.06a4,4,0,0,1,4-4H167.61a4,4,0,0,1,1.95.5l48.86,27.21a4,4,0,0,0,4-.05L420.76,82.94a4,4,0,0,0,2-3.49l-.38-44.89a4,4,0,0,1,1.84-3.41L455.34,11.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a025b3d4-20ef-458b-8ca9-33e39a132cab",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M11.79,244.41V175.06a4,4,0,0,1,4-4H167.61a4,4,0,0,1,1.95.5l48.86,27.21a4,4,0,0,0,4-.05L420.76,82.94a4,4,0,0,0,2-3.49l-.38-44.89a4,4,0,0,1,1.84-3.41L455.34,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fca2b066-e4da-4518-ada7-b9c6f6a890e0",
    d: "M11.79,244.41V175.06a4,4,0,0,1,4-4H167.61a4,4,0,0,1,1.95.5l48.86,27.21a4,4,0,0,0,4-.05L420.76,82.94a4,4,0,0,0,2-3.49l-.38-44.89a4,4,0,0,1,1.84-3.41L455.34,11.3"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.77517366.svg";
export { ForwardRef as ReactComponent };